import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { Field } from 'formik';
import { useFieldHasErrors } from '../utils';
import { TopArrowIcon } from './TopArrowIcon';
import { BottomArrowIcon } from './BottomArrowIcon';
import * as styles from '../../index.css';

export const Comment = () => {
  const [isCommentOpen, setIsCommentOpen] = React.useState(false);
  const invalid = useFieldHasErrors('comment');
  const toggleIsCommentOpen = React.useCallback(() => setIsCommentOpen(!isCommentOpen), [isCommentOpen]);

  return (
    <div {...mergeStyles(styles['field'], styles['span-columns'])}>
      <div onClick={toggleIsCommentOpen} {...mergeStyles(styles['label-comment'], invalid && styles['label-invalid'])}>
        <span className={styles['comment-text']}>Комментарий</span>
        {isCommentOpen ? TopArrowIcon : BottomArrowIcon}
      </div>
      {isCommentOpen && (
        <Field name="comment" type="text" as="textarea" className={styles['textarea']} rows={6} maxLength="500" />
      )}
    </div>
  );
};
